package ai.flowstorm.studio.ui.data

import ai.flowstorm.studio.ui.ReportPanel

class ReportPanel: ReportPanel()